// components/subscription/SubscriptionDetails.jsx
import React from 'react';
import { useSubscription } from '../../contexts/SubscriptionContext';

const SubscriptionDetails = () => {
  const { 
    activeSubscription, 
    // currentPlan, 
    loading, 
    error,
    cancelUserSubscription,
    renewUserSubscription
  } = useSubscription();

  if (loading) return <div className="text-center py-8">Loading subscription details...</div>;
  if (error) return <div className="text-center text-red-600 py-8">{error}</div>;
  if (!activeSubscription) return <div className="text-center py-8">No active subscription</div>;

  // const startDate = new Date(activeSubscription.start_date).toLocaleDateString();
  // const endDate = new Date(activeSubscription.end_date).toLocaleDateString();
  
  const handleCancel = async () => {
    if (window.confirm('Are you sure you want to cancel your subscription?')) {
      try {
        await cancelUserSubscription(activeSubscription.id);
        alert('Subscription canceled successfully');
      } catch (error) {
        alert('Failed to cancel subscription');
      }
    }
  };

  const handleRenew = async () => {
    try {
      await renewUserSubscription(activeSubscription.id);
      alert('Subscription renewed successfully');
    } catch (error) {
      alert('Failed to renew subscription');
    }
  };
  console.log('ActiveSubscription', activeSubscription, typeof(activeSubscription));
  return (
    <div className="bg-white border border-gray-200 rounded-lg p-6">
      <h2 className="text-xl font-semibold mb-4">Your Subscription</h2>
      
      <div className="mb-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <h3 className="text-sm text-gray-600 mb-1">Plan</h3>
            <p className="font-medium">{activeSubscription.plan_name}</p>
          </div>
          <div>
            <h3 className="text-sm text-gray-600 mb-1">Status</h3>
            <p className="font-medium">
              <span className={`px-2 py-1 rounded text-xs ${
                activeSubscription.status === 'active'
                  ? 'bg-green-100 text-green-800'
                  : activeSubscription.status === 'canceled'
                  ? 'bg-red-100 text-red-800'
                  : 'bg-yellow-100 text-yellow-800'
              }`}>
                {activeSubscription.status.toUpperCase()}
              </span>
            </p>
          </div>
          <div>
            <h3 className="text-sm text-gray-600 mb-1">Start Date</h3>
            <p className="font-medium">{new Date(activeSubscription.start_time).toLocaleDateString()}</p>
          </div>
          <div>
            <h3 className="text-sm text-gray-600 mb-1">End Date</h3>
            <p className="font-medium">{new Date(activeSubscription.expires_at).toLocaleDateString()}</p>
          </div>
        </div>
      </div>
      
      <div className="flex space-x-4">
        {activeSubscription.status === 'active' && (
          <button
            onClick={handleCancel}
            className="px-4 py-2 border border-red-500 text-red-500 rounded-md hover:bg-red-50"
          >
            Cancel Subscription
          </button>
        )}
        
        {activeSubscription.status === 'canceled' && (
          <button
            onClick={handleRenew}
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          >
            Renew Subscription
          </button>
        )}
      </div>
    </div>
  );
};

export default SubscriptionDetails;